<mat-toolbar>
  <img class="logo fx-hide-xs" id="" alt="logo" src="../../assets/ubi_logo.jpg">
  <img class="logo mobile-only fx-hide-gtxs" src="../../assets/ubi_logo.jpg" id="" alt="logo">

  <span class="empty-space"></span>

  <p class="fx-hide-xs font-size-small m-0-important">Powered by</p>
  <img class="logo fx-hide-xs h-32px mr-16px" src="../assets/whatsloan.png" alt="WhatsLoan">
  <img class="logo mobile-only fx-hide-gtxs h-45px" src="../assets/wl-logo.png" alt="WhatsLoan">
</mat-toolbar>

<router-outlet></router-outlet>

